import { render, staticRenderFns } from "./popularProducts.vue?vue&type=template&id=56a98d60&scoped=true&"
import script from "./popularProducts.vue?vue&type=script&lang=ts&"
export * from "./popularProducts.vue?vue&type=script&lang=ts&"
import style0 from "./popularProducts.vue?vue&type=style&index=0&id=56a98d60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../wellness/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a98d60",
  null
  
)

export default component.exports